"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageService = void 0;
var StorageService = /** @class */ (function () {
    function StorageService(storage) {
        this.storage = storage;
    }
    StorageService.prototype.setItem = function (key, value) {
        var valueToSet = value;
        if (typeof value !== 'string') {
            valueToSet = JSON.stringify(value);
        }
        this.storage.setItem(this.transformKey(key), valueToSet);
    };
    StorageService.prototype.removeItem = function (key) {
        this.storage.removeItem(this.transformKey(key));
    };
    StorageService.prototype.getItem = function (key) {
        return this.storage.getItem(this.transformKey(key));
    };
    StorageService.prototype.getItemAsObject = function (key) {
        var strValue = this.storage.getItem(this.transformKey(key));
        if (strValue) {
            return JSON.parse(strValue);
        }
    };
    StorageService.prototype.getAllKeys = function (filter) {
        var keys = [];
        for (var i = 0; i < this.storage.length; i++) {
            var key = this.storage.key(i);
            if (key && key.startsWith(StorageService.KEY_PREFIX)) {
                if (filter && !filter(key)) {
                    continue;
                }
                var transformedKey = key.substr(StorageService.KEY_PREFIX.length);
                keys.push(transformedKey);
            }
        }
        return keys;
    };
    StorageService.prototype.transformKey = function (key) {
        return "" + StorageService.KEY_PREFIX + key;
    };
    StorageService.KEY_PREFIX = '__seismicCommon__';
    return StorageService;
}());
exports.StorageService = StorageService;
//# sourceMappingURL=StorageService.js.map